export const INSPIRATION_HUB_TITLE = 'Not Another Blog';
export const INSPIRATION_HUB_INTRO =
  "Looking for inspiration? We've got it. Find everything you need right here from gift guides to lifestyle tips, all inspired by the UK's best small brands.";
